// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/pavilions.less
// module id = 419
// module chunks = 0